import React, { useEffect, useRef, useState } from 'react';
import {
  Container,
  Box,
  Tooltip,
  IconButton,
  Typography,
  Grid,
  Switch,
  TextField
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { httpRequest } from '../../../services/httpRequest';
import { useDispatch } from 'react-redux';
import toast from 'react-hot-toast';
import CustomModal from 'src/ui-component/customModal/CustomModal';
import { format } from 'date-fns';
import CustomSearchBar from 'src/ui-component/CustomSearchBar';
import CustomTable from 'src/ui-component/CustomTable/Index';
import { handleError } from 'src/redux-store/slices/errorSlice';
import PageTabTitle from 'src/components/PageTabTitle';
import Breadcrumb from 'src/ui-component/Breadcrumb';

const PermitsCloseOut: React.FC = () => {
  const messageBodyRef = useRef<string>('');
  const dispatch = useDispatch();
  const [searchVal, setSearchVal] = useState('');
  const description = 'Test';
  const [filteredRows, setFilteredRows] = useState([]);
  const [isSearch, setIsSearch] = useState(0);
  const [pagination, setpagination] = useState(0);
  const [loading, setLoading] = useState(true);
  const [CloseAppId, setCloseAppId] = useState('');
  const [IsOpen, setIsOpen] = useState<boolean>(false);
  const [applicationsListData, setApplicationListData] = useState<any>({
    columns: [
      'Owner Name',
      'Property Address',
      'Application Number',
      'Replacement Tree Quantity',
      'Approved Date',
      'Replacement Due Date',
      'Status',
      'Actions'
    ],
    rows: []
  });

  const fetchApplications = async () => {
    setLoading(true);
    const url = `/tree_permit_application/permit_close_out`;
    const response = await httpRequest('GET', url);
    if (response?.status === 'success') {
      const formattedRows = [];
      response.data.data.forEach((item: any) => {
        formattedRows.push({
          OwnerName: item.OwnerName,
          PropertyAddress: item.PropertyAddress,
          ApplicationNumber: item.ApplicationNumber,
          replacementtreeQuantity: item.ReplacementTrees,
          approvedDate: format(new Date(item.ApprovedDate), 'MM/dd/yyyy'),
          replacementDueDate: format(
            new Date(item.ReplacementDueDate),
            'MM/dd/yyyy'
          ),
          status: (
            <span
              style={{
                color:
                  item.ApplicationStatus === 'Approved Closed'
                    ? '#8B0000'
                    : 'green'
              }}
            >
              {item.ApplicationStatus}
            </span>
          ),
          Action: (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              {item.ApplicationStatus === 'Approved Closed' ? (
                <Tooltip title="Application info" arrow>
                  <IconButton
                    onClick={() =>
                      dispatch(handleError(`Description : ${item.ClosedMemo}`))
                    }
                  >
                    <InfoIcon color="primary" />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="Close Application" arrow>
                  <IconButton>
                    <Switch
                      checked={item.ApplicationStatus === 'Approved Closed'}
                      onChange={(e) => {
                        setCloseAppId(item.ApplicationID);
                        setIsOpen(e.target.checked);
                      }}
                    />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          )
        });
      });
      setApplicationListData({ ...applicationsListData, rows: formattedRows });
    } else if (response?.type === 'NETWORK_ERROR') {
    } else {
      toast.error(response?.message);
      dispatch(handleError(response?.message));
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!CloseAppId) fetchApplications();
  }, [CloseAppId]);

  useEffect(() => {
    const filteredData = applicationsListData.rows;
    setFilteredRows(filteredData);
  }, [applicationsListData]);

  const handleClosed = async () => {
    if (description) {
      setLoading(true);
      const response = await httpRequest(
        'POST',
        `/tree_permit_application/${CloseAppId}/permit_closed`,
        {
          ClosedMEMO: messageBodyRef.current
        }
      );
      if (response.status === 'success') {
        setIsOpen(false);
        fetchApplications();
        toast.success('Application closed successfully.');
        messageBodyRef.current = '';
      } else if (response?.type === 'NETWORK_ERROR') {
      } else {
        setIsOpen(false);
        dispatch(handleError(response?.message));
        messageBodyRef.current = '';
      }
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } else {
      toast.error('Please fill require fields.');
      messageBodyRef.current = '';
    }
  };

  return (
    <Container sx={{ mt: 2 }} className="main-table-container">
      <Breadcrumb
        PermitName={'Tree Removal'}
        PageTitle={'Close Out Applications'}
      />
      <PageTabTitle title="Draft Applications" />
      <Grid container gap={2} justifyContent={'space-between'}>
        <Grid
          item
          md={3}
          lg={3}
          xl={2}
          xs={12}
          sm={12}
          display={'flex'}
          alignItems={'center'}
        >
          <Typography variant="h3" fontSize={'22px'} color={'#6E759F'}>
            Tree Permit Close Out
          </Typography>
        </Grid>

        <Grid item md={3} lg={3} xl={2} xs={12} sm={12}>
          <CustomSearchBar
            rows={applicationsListData.rows}
            setFilteredRows={setFilteredRows}
            setpagination={setpagination}
            setIsSearch={setIsSearch}
            searchVal={searchVal}
            setSearchVal={setSearchVal}
          />
        </Grid>
      </Grid>
      <Box mt={2}>
        <CustomTable
          pagination={pagination}
          rows={filteredRows}
          columns={applicationsListData.columns}
          isSearch={isSearch}
        />
      </Box>
      <CustomModal
        title={'Tree Permit Closeout Confirmation'}
        IsOpen={IsOpen}
        setIsOpen={setIsOpen}
        messageBodyRef={messageBodyRef}
        onSave={() =>
          !messageBodyRef.current
            ? toast.error('Description field is required !')
            : handleClosed()
        }
        actionButtons={['Cancel', 'Send']}
        loading={loading}
        content={
          <TextField
            className="txtArea"
            label="Description *"
            placeholder="Description *"
            name="description "
            multiline
            onChange={(e) => (messageBodyRef.current = e.target.value)}
            sx={{ width: '600px' }}
            rows={3}
          />
        }
      />
    </Container>
  );
};

export default PermitsCloseOut;
